<template>
  <div
    class="a-textarea"
    :class="{
      '-has-text': fieldHasText,
      '-invalid': fieldHasError
    }"
  >
    <label class="a-textarea__label" :for="fieldId ? fieldId : name">
      <!-- @slot Custom input label -->
      <slot name="label" v-bind="{ label }">{{ label }}</slot>
    </label>
    <div class="a-textarea__wrapper">
      <textarea
        :id="fieldId ? fieldId : name"
        v-bind="$attrs"
        :value="( Array.isArray(value) ? $firstOrDefault(value) : value)"
        :disabled="disabled"
        :name="name"
        :aria-label="ariaLabel"
        :rows="rows"
        v-on="listeners"
        @input="resize"
      />
      <span v-if="showFeedbackIcon" class="a-textarea__icon">
        <base-icon v-if="!fieldHasErrror && !!value" class="a-textarea__icon--success" icon="checkmarkOutlined" />
        <base-icon v-else-if="fieldHasErrror" class="a-textarea__icon--error" icon="attention" />
      </span>
    </div>
    <div v-if="fieldHasError" class="a-input__error-message">
      <transition name="fade">
        <span v-if="errorMessage != ''">
          <!-- @slot Custom error message of form input -->
          <slot name="error-message" v-bind="{ errorMessage }">
            {{ errorMessage }}
          </slot>
        </span>
        <span v-else>
          {{ error.msg }}
        </span>
      </transition>
    </div>
  </div>
</template>
<script>
import BaseIcon from './BaseIcon.vue'
export default {
  name: 'BaseInput',
  components: {
    BaseIcon
  },
  props: {
    fieldId: {
      type: String,
      default: ''
    },
    /**
     * Current textarea value (`v-model`)
     */
    value: {
      type: [String, Number, Array],
      default: null
    },
    /**
     * Form textarea label
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Form textarea name
     */
    name: {
      type: String,
      default: null
    },
    /**
     * Form textarea type
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Error message value of form textarea. It will be appeared if `valid` is `true`.
     */
    errorMessage: {
      type: String,
      default: null
    },
    /**
     * Native textarea disabled attribute
     */
    disabled: {
      type: Boolean,
      default: false,
      description: 'Native textarea disabled attribute'
    },
    /**
     * Form textarea aria-label
     */
    ariaLabel: {
      type: String,
      default: null
    },
    /**
     * Form textarea cols
     */
    rows: {
      type: Number,
      default: 1
    },
    /**
     * Show feedback icon
     */
    showFeedbackIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fieldHasText () {
      let val = Array.isArray(this.value) ? this.$firstOrDefault(this.value) : this.value

      return (!!val || val.length > 0 )
    },
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value)
      };
    },
    fieldHasError () {
      return typeof (this.errors) !== 'undefined' && this.errors.items.find(x => x.field === this.name) != null;
    },
    error () {
      return typeof (this.errors) !== 'undefined' && this.errors.items.find(x => x.field === this.name);
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$el.setAttribute('style', 'height',
      `${this.$el.scrollHeight}px`);
    });
  },
   methods: {
    resize (event) {
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`;
    }
  }
};
</script>
